<template>
  <div>
    <el-container>
      <el-header height="60px">
        <div style="display: flex; align-items: center; height: 100%">
          <div
            style="
              padding: 0 20px;
              font-weight: bold;
              font-size: 20px;
              color: #303133;
              min-width: 600px;
            "
            class="ellipsis"
            :title="ProjectInfo.Name"
          >
            项目名称：{{ ProjectInfo.Name }}
          </div>
          <div
            style="
              display: flex;
              align-items: center;
              height: 100%;
              flex: 1;
              justify-content: right;
            "
          >
            <div
              style="
                display: flex;
                align-items: center;
                margin-right: 10px;
                justify-content: right;
              "
            >
              <div
                style="margin-right: 20px; color: #f56c6c; width: 300px"
                v-if="oneInfo.SupplierStaus != 1"
                class="ellipsis2"
              >
                <el-tooltip
                  class="tooltipitem"
                  effect="dark"
                  style="height: 100%"
                  placement="left-start"
                >
                  <div slot="content" class="missing-equipment-tooltip">
                    <div class="missing-equipment-title">
                      下面的设备资料未进行上报：
                    </div>
                    <div class="missing-equipment-list">
                      <span
                        v-for="(item, idx) in missingEquipmentList"
                        :key="item + idx"
                      >
                        <i></i> {{ item }}
                      </span>
                    </div>
                  </div>
                  <span
                    style="font-size: 14px; color: #f56c6c"
                    class="ellipsis2"
                    ><i class="el-icon-bell"></i>
                    <span>
                      {{
                        missingEquipmentList.length
                          ? `下面的设备资料未进行上报：${missingEquipmentText}`
                          : oneInfo.Content
                      }}
                    </span>
                  </span>
                </el-tooltip>
              </div>

              <el-button
                type="primary"
                size="mini"
                style="padding: 10px"
                @click="openInvitersList"
                v-if="Grade == '1'"
                >邀请分包商</el-button
              >
              <el-button
                type="primary"
                size="mini"
                style="
                  width: 60px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin-right: 10px;
                "
                icon="el-icon-question"
                @click="openHelp"
                >帮助</el-button
              >
              <div style="font-size: 14px; width: 140px">{{ date }}</div>
              <div
                style="margin-left: 10px; margin-right: 10px; cursor: pointer"
                @click="openInfo"
              >
                <el-badge
                  :value="UnreadTotal"
                  :max="99"
                  :hidden="UnreadTotal == 0"
                  v-if="Grade == '1' || Grade == '3'"
                >
                  <i
                    class="el-icon-chat-line-round"
                    style="font-size: 30px; color: #909399"
                  ></i>
                </el-badge>
              </div>
              <div
                style="
                  margin-right: 5px;
                  margin-left: 10px;
                  cursor: pointer;
                  width: 45px;
                "
                @click="$router.push('/TemplateUser')"
              >
                <el-avatar
                  :size="40"
                  fit="cover"
                  :src="SupplierInfo.UserAvatarURL"
                  icon="el-icon-user-solid"
                ></el-avatar>
              </div>
              <div style="font-size: 14px; width: 100px" class="ellipsis2">
                {{ SupplierInfo.cVenName }}
              </div>
              <div style="margin: 0px 15px; cursor: pointer" @click="logOut">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="退出登录"
                  placement="bottom"
                >
                  <i
                    class="el-icon-switch-button"
                    style="font-size: 30px; font-weight: 900; color: #409eff"
                  ></i>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </el-header>
      <el-main style="height: calc(100vh - 60px); overflow: hidden">
        <router-view></router-view>
      </el-main>
      <TemplateInvitersList ref="TemplateInvitersList" />
      <TemplateNews ref="TemplateNews" @close="getMessageCount"></TemplateNews>
    </el-container>
  </div>
</template>
<script>
import TokenCache from '@/utils/cache/TokenCache'
import moment from 'moment'
import TemplateNews from './TemplateNews.vue'
import TemplateInvitersList from './TemplateInvitersList.vue'
export default {
  data() {
    return {
      date: '',
      oneInfo: {},
      ProjectInfo: {},
      SupplierInfo: {},
      Grade: null,
      UnreadTotal: '',
    }
  },
  props: {},
  components: { TemplateNews, TemplateInvitersList },
  methods: {
    getInfoOne() {
      this.loading = true
      this.$http
        .post(
          '/Operation_Manage/Operation_Notify/GetSupplierSideOperationNotifyList',
          {
            PageIndex: 1,
            PageRows: 10,
            SortField: 'CreateTime',
            SortType: 'desc',
            Search: [
              {
                Condition: 'ProjectId',
                Keyword: this.ProjectInfo.Id,
              },
              {
                Condition: 'SupplierId',
                Keyword: this.SupplierInfo.Id,
              },
              {
                Condition: 'Type',
                Keyword: 1,
              },
            ],
          }
        )
        .then((res) => {
          this.loading = false
          if (res.Success) {
            if (res.Data && res.Data.length > 0) {
              this.oneInfo = res.Data[0] || {}
            }
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    getMessageCount() {
      console.log(11111111)
      console.log(this.Grade)

      this.$http
        .post(
          '/Operation_Manage/Operation_Notify/GetSupplierSideOperationNotifyCount',
          {
            Search: [
              {
                Condition: 'ProjectId',
                Keyword: this.ProjectInfo.Id,
              },
              {
                Condition: 'SupplierId',
                Keyword: this.SupplierInfo.Id,
              },
            ],
          }
        )
        .then((res) => {
          if (res.Success) {
            this.UnreadTotal = res.Data || 0
          }
        })
    },
    openInfo() {
      this.$refs.TemplateNews.openDrawer(
        this.SupplierInfo.Id,
        this.ProjectInfo.Id
      )
    },
    /**
     * 打开邀请人列表
     */
    openInvitersList() {
      this.$refs.TemplateInvitersList.ProjectInfo = this.ProjectInfo
      this.$refs.TemplateInvitersList.SupplierInfo = this.SupplierInfo
      this.$refs.TemplateInvitersList.open({
        ProjectId: this.ProjectInfo.Id,
        SupplierId: this.SupplierInfo.Id,
      })
    },
    /**
     * 打开帮助
     */
    openHelp() {
      window.open('http://120.46.133.253:10003/')
    },
    async logOut() {
      TokenCache.deleteToken()
      this.$store.state.userInfo = {}
      await this.$store.dispatch('setUser', false)
      // this.$store.state.isLogin = false;
      let ProjectId = window.localStorage.getItem('exeProjectId')
      this.$router.replace('/TemplateLogin?ProjectId=' + ProjectId)
    },
  },
  mounted() {
    this.date = moment().format('YYYY-MM-DD HH:mm:ss')
    setInterval(() => {
      this.date = moment().format('YYYY-MM-DD HH:mm:ss')
    }, 1000)
  },
  created() {
    if (!TokenCache.getToken()) {
      return this.$router.replace(
        '/TemplateLogin?ProjectId=' +
          window.localStorage.getItem('exeProjectId')
      )
    }
    this.ProjectInfo = window.localStorage.getItem('exeProjectInfo')
      ? JSON.parse(window.localStorage.getItem('exeProjectInfo'))
      : {}
    this.SupplierInfo = window.localStorage.getItem('base_Supplier')
      ? JSON.parse(window.localStorage.getItem('base_Supplier'))
      : {}
    this.Grade = window.localStorage.getItem('Grade')
  },
  computed: {
    missingEquipmentList() {
      const raw = this.oneInfo?.Content
      if (!raw) return []
      let text = raw.replace(/通知[:：]\s*/g, '').trim()
      text = text.replace(/设备分类未填写信息[。\.]?$/g, '').trim()
      const blacklist = ['设备分类', '设备分类未填写信息', '通知']
      return text
        .split(/[,，]/)
        .map((item) => item.trim())
        .filter((item) => item && !blacklist.includes(item))
    },
    missingEquipmentText() {
      return this.missingEquipmentList.join('，')
    },
  },
  watch: {
    $route: {
      handler(n, o) {
        this.SupplierInfo = window.localStorage.getItem('base_Supplier')
          ? JSON.parse(window.localStorage.getItem('base_Supplier'))
          : {}
        console.log(11111)
        this.getMessageCount()
        this.getInfoOne()
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>
<style lang="scss" scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.el-button {
  padding: 10px;
}
::v-deep .el-badge__content {
  right: 18px;
}
::v-deep .tooltipitem {
  height: 100%;
}
.missing-equipment-tooltip {
  font-size: 14px;
  width: 420px;
}
.missing-equipment-title {
  font-weight: 600;
  margin-bottom: 8px;
  color: #ffd04b;
}
.missing-equipment-list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px 12px;
  color: #fff;
}
.missing-equipment-list span {
  display: block;
  word-break: break-all;
}
.missing-equipment-list span i {
  display: inline-block;
  margin-right: 4px;
  color: #ffd04b;
  width: 8px;
  height: 8px;
  background-color: #ffd04b;
}
</style>
